// extracted by mini-css-extract-plugin
module.exports = {"notFound":"NotFound_notFound__2sp7O","title":"NotFound_title__ah28v","description":"NotFound_description__3Bzn8","button":"NotFound_button__3JZdL","link":"NotFound_link__SPICF"};